module.exports = __webpack_public_path__ + "static/media/CiscoSansTTBold.0bed5803.ttf";